export default {
    state: {
        arr: {}
    },
    getters:{
        CCANCEL: state=> {
            return state.arr
        }
    },
    mutations: {
        SET_CCANCEL: (state,payload) =>{
            state.arr=payload
            state.arr.actual='1'
        },
        SET_CCANCEL_ACTUAL: (state,actual) =>{
            state.arr.actual=actual
        }
    },
    actions: {
        SET_CCANCEL: (context, payload) => {
             context.commit('SET_CCANCEL',payload)
        },
        SET_CCANCEL_ACTUAL: (context, actual) => {
            context.commit('SET_CCANCEL_ACTUAL',actual)
        }
    },

}